import { render, staticRenderFns } from "./LitePage3.vue?vue&type=template&id=08e913eb&scoped=true"
import script from "./LitePage3.vue?vue&type=script&lang=js"
export * from "./LitePage3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e913eb",
  null
  
)

export default component.exports